<div class="tile d-flex flex-column justify-content-between">
  <div>
    @if (strategy.imageUrl) {
      <div class="image">
        <img [src]="imageBase + '/' + strategy.imageUrl" alt="strategy" />
      </div>
    }
    @if (strategy.title) {
      <h5 class="mt-3">{{ strategy.title }}</h5>
    }
    @if (strategy.description) {
      <p class="mt-2 mb-0">{{ strategy.description }}</p>
    }
  </div>
  <div>
    <a [routerLink]="url + '/' + strategy.id" class="link-secondary">
      {{ 'my-home.multi-order-strategy-card.more' | transloco }}
    </a>
  </div>
</div>
